import {UnknownServerData} from '@practicegenius/http-clients-js/src/types';

export function getContactId(
  account: UnknownServerData,
  contacts: UnknownServerData[] | undefined
): string | null {
  const contactSubType = account.use_responsible_email
    ? 'responsible'
    : 'primary';

  const selectedContact = contacts?.find(
    contact => contact.type === 'email' && contact.sub_type === contactSubType
  );

  return selectedContact?.verification_identifier ?? null;
}

export function cleanCardNumber(
  cardNumber?: string | null
): string | undefined {
  return cardNumber?.replace(/\s+/g, '');
}
